/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentScenarioControllerUpdateMutationResponse, IncidentScenarioControllerUpdatePathParams } from "../../models/incidentAgentController/IncidentScenarioControllerUpdate";

function getIncidentScenarioControllerUpdateUrl(id: IncidentScenarioControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/incident-agent/scenarios/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/scenarios/:id}
 */
export async function incidentScenarioControllerUpdate(id: IncidentScenarioControllerUpdatePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentScenarioControllerUpdateMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PATCH", url : getIncidentScenarioControllerUpdateUrl(id).url.toString(), ... requestConfig })  
  return res.data
}